/**
 * The code between MixinRestore and the MixinTemplate is almost identical. When making change to one, consider other file as well.
 */
import { useConnectionsStore } from '@/stores/ConnectionsStore'
import axios from 'axios'

const restorePhpFile = 'restore.php'

export default {

    methods: {

        async restoreLoadRestorePoints () {

            let params = {}

            const connectionsStore = useConnectionsStore()

            params.currentConnection = connectionsStore.getCurrentConnection()
            params.operation = 'get_restore_points'

            return await axios.get(restorePhpFile, {
                params
            }).then((response) => {
                return response.data

            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })
        },

        async restoreProcessRestore () {

            let self = this

            const connectionsStore = useConnectionsStore()

            let params = new FormData()
            params.append('currentConnection', JSON.stringify(connectionsStore.getCurrentConnection()))
            params.append('operation', 'restore')
            params.append('chosenRestorePoint', self.chosenRestorePoint)
            params.append('restoreChannel', self.restoreChannel)

            if (self.restoreChannel === 'disk') {
                params.append('restoreFile', self.restoreFile[0])
            }

            return await axios.post(restorePhpFile, params).then((response) => {
                return response.data
            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })

        }
    }

}
